import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import App from "layouts/App";
import store from "stores/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard.css?v=1.2.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
import * as Sentry from "@sentry/react";
import posthog from 'posthog-js'

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  environment: process.env.REACT_APP_ENV,
  person_profiles: 'identified_only',
  // Session recording options (matching your original intent)
  session_recording: {
    maskAllInputs: false,
    maskAllText: false,
    maskTextSelector: ".posthog-mask"
  },
  maskInputOptions: {
    password: true,
    credit_card: true
  },
  // Capture pageviews automatically
  capture_pageview: true,
  // Capture page leaves
  capture_pageleave: true,
  // Cross subdomain cookie (useful if you have multiple subdomains)
  cross_subdomain_cookie: true,
  // Loaded callback for error tracking
  loaded: function(posthog) {
    // Track JavaScript errors
    window.addEventListener('error', function(event) {
      posthog.capture('javascript_error', {
        error_message: event.error && event.error.message,
        error_stack: event.error && event.error.stack,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        user_agent: navigator.userAgent,
        url: window.location.href
      });
    });

    // Track unhandled promise rejections
    window.addEventListener('unhandledrejection', function(event) {
      posthog.capture('unhandled_promise_rejection', {
        reason: event.reason,
        promise: event.promise,
        url: window.location.href
      });
    });
  }
});

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText:false,
      blockAllMedia:false
    }),
  ],
  tracesSampleRate: 1.0, 
  replaysSessionSampleRate: 0.5,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.REACT_APP_ENV,
});

if (module.hot) {
  module.hot.accept();
}

window.store = store;

ReactDOM.render(
	<Provider store={store}>
	  <App />
  </Provider>,
  document.getElementById("root")
);
